import React from 'react';
import { ScienceBackdata } from '../../../constant/Data';

const ScienceBack = () => {


    return (
        <section className="pb-20" id="science-back">
            <div className="max-w-7xl mx-auto px-4">
                <h2 className="text-3xl font-bold text-center mb-4 text-navy-900">
                Research-Backed breathing support.
                </h2>
                <p className="text-gray-600 text-center mb-12">
                Our revolutionary formula targets lung health at the source.</p>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {ScienceBackdata.map(item => (
                        <div class="bg-white rounded-2xl shadow-md flex flex-col items-center text-center transform transition-transform duration-300 ease-in-out hover:scale-105">
                            <img src={item.imageSrc} alt={item.alt} class="rounded-t-xl w-full hover:opacity-90 duration-150 ease-in-out" />
                            <div class="p-4">
                                <h3 class="font-semibold text-xl text-[#212529]">{item.title}</h3>
                                <p class="text-gray-600 text-sm">{item.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default ScienceBack;
